import {styled, Box, IconButton, clsx} from "external/material"
import useTranslations from "hooks/translations"
import { flexGrow } from 'utils/style'

import DashboardRefreshData from './DashboardRefreshData'
import DashboardTodayButton from './DashboardTodayButton'
import { SideMenuCloseIcon } from "resources/icons"

const StyledSidebarTopbar = styled(Box)(sidebarTopbarStyles)

export default function DashboardSidebarTopbar(props) {

    const {translate} = useTranslations()

    return (
        <StyledSidebarTopbar className={clsx({canCloseSidebar: props.canCloseSidebar})}>
            {props.canCloseSidebar && <IconButton className="close-menu" onClick={() => props.setMenuOpen(false)}><SideMenuCloseIcon height={24} /></IconButton>}
            <DashboardRefreshData />
            <Box style={flexGrow()} />
            <DashboardTodayButton
                label={translate('today_label')}
                active={props.displayingToday}
                onCalendarChange={props.onCalendarChange}
            />
        </StyledSidebarTopbar>
    )
}

function sidebarTopbarStyles() {
    return {
        display: 'flex',
        flexShrink: 0,
        padding: '8px 0',
        "&.canCloseSidebar": {
            padding: '8px 0 8px 38px',
        },
        justifyContent: 'flex-end',
        "& .close-menu": {
            position: 'absolute',
            top: 1,
            left: 0
        }
    }
}


